import { useDropzone } from 'react-dropzone';
import { Button } from '@mui/material';
import React, { useEffect } from 'react';
import { MdClose, MdCheck } from "react-icons/md";
import { FiFileText } from "react-icons/fi";

interface Props {
    onFileUploaded: (file: any) => void,
}


const BulkUploadFileUploader: React.FC<Props> = props => {
    const { onFileUploaded } = props;

    const {
        acceptedFiles, isDragActive,
        isDragAccept,
        isDragReject, getRootProps, getInputProps
    } = useDropzone({
        accept: {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xls'],
        },
    });

    useEffect(() => {
        onFileUploaded(acceptedFiles?.[0]);
    }, [acceptedFiles])

    const picked = acceptedFiles?.[0];

    // Drop area like the image uploaders: icon, short instructions, what is accepted, and a browse button.
    return (
        <div {...getRootProps({ className: "pb-dropzone pb-dropzone--file" + (isDragAccept ? " is-accept" : "") + (isDragReject ? " is-reject" : "") })}>
            <input {...getInputProps()} />
            <div className="pb-dropzone-icon">
                {isDragAccept ? <MdCheck /> : isDragReject ? <MdClose /> : <FiFileText />}
            </div>

            {isDragAccept && <div className="pb-dropzone-title">Drop to add</div>}
            {isDragReject && <div className="pb-dropzone-title text-danger">An invalid file was selected. Please ensure to use the previously generated template.</div>}

            {!isDragActive && <>
                <div className="pb-dropzone-title">Drag and drop the completed template here</div>
                <div className="pb-dropzone-text">or browse to add your completed bulk upload template.</div>
                <div className="pb-dropzone-chips">
                    <span>Excel template from step 1</span>
                </div>
                {picked && <div className="pb-dropzone-file"><FiFileText /> {picked.name}</div>}
                <Button className="btn-primary text-white text-capitalize pb-dropzone-button">
                    {picked ? "Choose Another File" : "Browse Completed Template"}
                </Button>
            </>}
        </div>
    );
}

export default BulkUploadFileUploader